import messages from './utils/messages'

const GETTERS = {
  currentMessage(state, getters, rootState, rootGetters) {
    const reportKey = rootGetters['tools/reportKey']
    const { views } = state

    return !!reportKey && views[reportKey]
  },
  messageViews(state) {
    const { views } = state
    return views
  },
  statusCodes(state, getters, rootState, rootGetters) {
    const { statusCodes } = messages
    const isCustomReportUser = rootGetters['auth/isCustomReportUser']
    const customReports = rootGetters['auth/customReports']

    if (isCustomReportUser) {
      const errorIndex = statusCodes.findIndex((status) => status.code === 400)
      const error400 = statusCodes[errorIndex]
      const newError400 = { ...error400, options: customReports }

      statusCodes.splice(errorIndex, 1, newError400)
    }

    return statusCodes
  },
}

export default GETTERS
